export class ValidateDataCatalogPipelineRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "definition",
            "baseName": "definition",
            "type": "DataCatalogPipelineDefinition",
            "format": ""
        },
        {
            "name": "pipelineId",
            "baseName": "pipelineId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ValidateDataCatalogPipelineRequest.attributeTypeMap;
    }
    constructor() {
    }
}
